// extracted by mini-css-extract-plugin
export var discard = "_3z-3";
export var muiTooltipTooltip = "_3z-5";
export var notificationBar = "_3z-2";
export var saveButtonHoverSlotWrapper = "_3z-4";
export var show = "_3z-1";
export var spacer = "_3z-0";